import React, { useEffect, useState } from 'react';

const Intro = props => {
  const referrer = props.referrer;
  const [width, setWidth] = useState(props.width);
  const [title, setTitle] = useState(props.title);
  const [subTitles, setSubTitles] = useState(props.subTitles);

  useEffect(() => {
    if (props.title !== title) {
      setTitle(props.title);
    }
    if (props.subTitles !== subTitles) {
      setSubTitles(props.title);
    }
    if (props.width !== width) {
      setWidth(props.width);
    }
  }, [props.title, props.subTitles, props.width]);

  return (
    <>
      <div
        className={` bg-fixed relative matrixBlock intro-part  before:content-[attr(before)] w-full  min-h-640  xs:min-h-500  sm:min-h-600 md:min-h-800  lg:min-h-850  xl:min-h-910 before-purple `}
        data-before=""
      >
        <style jsx global>
          {`
            .matrixBlock {
              background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFgAAABaBAMAAADOc4wMAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAPUExURUdwTCUlJQAAAB4eHxISMKJ4dbYAAAAFdFJOUwAMAw4K9K3DwAAAAFVJREFUSMdjYEADygzYAIsCVuFRxaOKRxWPKh5VPDgUC6ICYWNBbMDYEEQyYBdGB8IQxcQ5g3E0UkYVjyoeVTyqeFTxqGK6VfT4626SWgWjFf0QVwwAarwlGbJ+rFkAAAAASUVORK5CYII=);
            }
            .block.container {
              left: 50%;
              transform: translate(-50%, 0%);
            }
            .before-purple:before {
              content: '';
              width: 33%;
              height: 100%;
              background: ${referrer === 'industry' ? '#670F7A' : '#8DC63F'};
              position: absolute;
              right: 0;
            }
            @media (max-width: 1024px) {
              .before-purple:before {
                background: ${referrer === 'industry' ? '#670F7A' : '#670F7A'};
                width: 100%;
                height: 33%;
                bottom: 0;
              }
            }
          `}
        </style>
        <div className="container flex flex-col sm:flex-col md:flex-col lg:flex-row justify-between  absolute bottom-0 w-full md:h-full h-full ">
          <div className="w-full xl:min-w-400   sm:w-full md:w-full lg:w-full text-center   flex items-center text-black pt-18">
            <div
              className={`text-part   uppercase font-black  ${referrer === 'industry' ? '' : 'text-green'} text-40 sm:text-45 md:text-40  lg:text-60 md:w-70p lg:w-85p  p-10 `}
            >
              <h1 className="text-left">
                {title}
                <span className={`block  ${referrer === 'industry' ? 'text-green' : 'text-purple'} `}>{subTitles}</span>
              </h1>
            </div>
          </div>
          {referrer === 'industry' ? (
            <div className=" absolute right-0 sm:right-0 md:right-0 lg:-right-50 xl:-right-200 sm:w-full md:w-2/3 lg:w-2/3  min-w-0 min-h-0 m-0 z-0 md:m-auto h-full md:f-full lg:h-full xl:h-full flex items-end justify-center ">
              <picture>
                <source media="(min-width:768px)" srcSet="/images/personages/industries.webp" type="image/webp" />
                <source media="(min-width:768px)" srcSet="/images/personages/industries.png" type="image/webp" />
                <source media="(max-width:767px)" srcSet="/images/personages/industries.png" type="image/png" />
                <img width={width > 728 ? 639 : 720} height={width > 768 ? 596 : 660} src="" className="hide" alt={'personage industry'} />
              </picture>
            </div>
          ) : (
            <div className="  sm:w-full md:w-2/3 lg:w-full  min-w-0 min-h-0 m-0 z-0 md:m-auto h-full md:f-full lg:h-full xl:h-full flex items-end justify-center ">
              <picture>
                <source media="(min-width:768px)" srcSet="/images/personages/privacy-policy.webp" type="image/webp" />
                <source media="(min-width:768px)" srcSet="/images/personages/privacy-policy.png" type="image/webp" />
                <source media="(max-width:768px)" srcSet="/images/personages/privacy-policy.png" type="image/png" />
                <img width={width < 768 ? 184 : 375} height={width < 768 ? 286 : 627} src="" className="hide" alt={'personage poluicy'} />
              </picture>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default Intro;
